import app from 'flarum/forum/app';

/**
 * A discussion's cover image.
 *
 * The first image in the first post that is not a smiley or an avatar. The
 * server picks it and sends just the URL (`blizznuxCover`, src/Cover.php), so
 * the discussion list does not have to carry the post. If the attribute is
 * absent, the post's rendered HTML is read here instead, by the same rule. When
 * there is no image, the site logo stands in, so every card has the same shape
 * and the grid never goes ragged.
 */
export function coverFor(discussion) {
  const fallback = {
    url: app.forum.attribute('logoUrl') || app.forum.attribute('faviconUrl') || '',
    isLogo: true
  };

  // null means the server looked and found no image; only undefined falls back.
  const served = discussion?.attribute?.('blizznuxCover');
  if (served) return {
    url: served,
    isLogo: false
  };
  if (served === null) return fallback;
  const post = discussion?.firstPost?.();
  const html = post?.contentHtml?.() || '';
  if (!html) return fallback;

  // Parsed rather than regexed: a regex over user HTML is how you end up
  // pulling a src out of an attribute that only looks like an image.
  let doc;
  try {
    doc = new DOMParser().parseFromString(html, 'text/html');
  } catch (e) {
    return fallback;
  }
  const imgs = Array.from(doc.querySelectorAll('img'));
  for (const img of imgs) {
    const src = img.getAttribute('src') || '';
    if (!src) continue;
    // Skip emoji and anything the size of an icon.
    if (/emoji|smiley|avatar/i.test(img.className + ' ' + src)) continue;
    return {
      url: src,
      isLogo: false
    };
  }
  return fallback;
}
flarum.reg.add('blizznux-home', 'forum/components/cover', { coverFor: coverFor, });